/**
 * Pure address helpers, kept out of `api/auth` on purpose: that module builds better-auth's client
 * at import time, which needs a real `window` with a real origin, so nothing there can be imported
 * by a test — the DOM suites mock the whole module instead. These two are plain string functions
 * and the sign-in screen's CTA gate depends on them, so they live where they can be tested for
 * real rather than against a copy of themselves in a mock.
 */

/** Addresses are matched case-insensitively, here and on the server: `Andre@x.com` and
 * `andre@x.com` must be one account, not two. `+tags` are deliberately left alone — to some people
 * `a+bet@gmail.com` genuinely is a different account. */
export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase()
}

/** Deliberately shallow: an address either can or cannot receive mail, and only sending finds out.
 * All this has to decide is whether the sign-in CTA has earned its fill yet — the old "not empty"
 * gate lit it up on the first keystroke, promising to send to `a`. Anything stricter starts
 * rejecting real addresses. */
export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(normalizeEmail(email))
}
